<!--
@Author: Tom Voorneveld <tom>
@Date:   2017-11-25T15:08:56+01:00
@Email:  tom@lorinthe.com
@Project: Lorinthe - Listing the company Services page
@Last modified by:   tom
@Last modified time: 2018-01-03T13:11:23+01:00
@Copyright: (c) copyright Lorinthe BV, all rights reserved
-->

<template>
  <c-page id="services"
        :title="$t('services.title')"
        :jbheader="$t('services.header')"
        :jblead="$t('services.payload')"
        sideimage="@/assets/img/services/consult.jpg"
  >
    <h2 class="text-secondary">
      {{ $t('services.subtitle') }}
    </h2>
    <p class="pb-4" v-html="$t('services.slot')" />

    <!-- service overview cards -->
    <b-row id="servicecards">
      <b-col
        v-for="f in 4"
        :key="f"
        md="6"
      >
        <b-card
          :title="$t('services.' + f + '.title')"
          :header="$t('services.' + f + '.caption')"
          :img-src="assetUrl('img/services/'+ $t('services.' + f + '.img'))"
          :img-alt="'Img ' + f"
        >
          <!-- Images 1200x 680 -->
          <p class="font-weight-light" v-html="$t('services.' + f + '.slot')" />
          <!-- include quote if we have one in the language file technology list -->
          <blockquote
            v-if="$te('services.' + f + '.block', 'en')"
            v-html="$t('services.' + f + '.block')"
          />
        </b-card>
      </b-col>
    </b-row>

    <!-- Prices -->
    <!-- <h2 class="text-secondary">{{ $t('services.prices.title') }}</h2>
    <b-row>
      <b-col cols="8 pr-0">
        <p v-html="$t('services.prices.caption')" />
        <router-link :to="{name:'Prices'}"
          class="btn btn-secondary mr-sm-2 btn-sm nav-item nav-last">
          {{ $t('services.prices.incentive') }}
        </router-link>
      </b-col>
      <b-col cols="4">
        <b-img :src="'/static/img/aboutus/'+ $t('services.prices.img')" fluid alt="Prices image" />
      </b-col>
    </b-row> -->
    <p>
      <router-link to="/#contact" class="btn btn-secondary mr-sm-2 btn-sm nav-item nav-last">
        {{ $t('contact.label') }}
      </router-link>
    </p>
  </c-page>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>

  #services {
    .img-fluid {
      margin-top: 2px;
      margin-left: 20px;
    }
    #servicecards {
      .card {
        margin-bottom: 20px;
      }
      .card-title {
        margin-top: 0 !important;
      }
    }
  }

</style>
